import { FormControl, HStack, Switch } from "@chakra-ui/react";
import React, { useState } from "react";

import { LoadingIndicator } from "../../../../components";

interface SettingSwitchProps {
  onToggle: (newValue: boolean) => Promise<any>;
  isChecked: boolean;
  children: React.ReactNode;
}

export const SettingSwitch: React.FC<SettingSwitchProps> = ({
  onToggle,
  isChecked,
  children,
}) => {
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setLoading(true);
    onToggle(e.target.checked)
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <HStack align="baseline" spacing="3" maxW="120px">
      {loading ? (
        <LoadingIndicator size="xs" alignSelf="flex-start" width="inherit" />
      ) : (
        <FormControl>
          <Switch
            colorScheme="prism"
            display="flex"
            alignItems="center"
            fontSize="sm"
            lineHeight={1.5}
            isChecked={isChecked}
            onChange={handleChange}
          >
            {children}
          </Switch>
        </FormControl>
      )}
    </HStack>
  );
};
